import { type MantineColorScheme } from '@mantine/core'
import Image from 'next/image'

// Wordmark ratio is 14:3 (112x24), so every size keeps integer dimensions
const SHALION_LOGO_SIZES = {
  xs: { width: 56, height: 12 },
  sm: { width: 84, height: 18 },
  md: { width: 112, height: 24 },
  lg: { width: 140, height: 30 },
  xl: { width: 168, height: 36 },
} as const

export type ShalionLogoSize = keyof typeof SHALION_LOGO_SIZES

type ShalionLogoProps = {
  colorScheme?: MantineColorScheme
  size?: ShalionLogoSize
}

const ShalionLogo = (props: ShalionLogoProps) => {
  const { colorScheme = 'light' as MantineColorScheme, size = 'md' } = props
  const { width, height } = SHALION_LOGO_SIZES[size]

  const logoUrl = `/assets/svg/shalion-logo-${colorScheme === 'light' ? 'light' : 'dark'}.svg`

  return <Image alt='Shalion Logo' height={height} src={logoUrl} width={width} />
}

export default ShalionLogo
